import { render, staticRenderFns } from "./ModuleShipping.vue?vue&type=template&id=6e6df426&scoped=true&"
import script from "./ModuleShipping.vue?vue&type=script&lang=js&"
export * from "./ModuleShipping.vue?vue&type=script&lang=js&"
import style0 from "./ModuleShipping.vue?vue&type=style&index=0&id=6e6df426&prod&lang=scss&scoped=true&"
import style1 from "./ModuleShipping.vue?vue&type=style&index=1&id=6e6df426&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6df426",
  null
  
)

export default component.exports